import shop1 from "./Images/Illustration/battery.jpg";
import shop2 from "./Images/Illustration/diskbreak.jpg";
import shop3 from "./Images/Illustration/wheel.jpg";
import shop4 from "./Images/Illustration/shock.jpg";
import shop5 from "./Images/Illustration/seat.jpg";

const Shop = () => {
    return (
        <section class='container-fluid shop'>
            <div class='row'>
                <div class='col-12 back2 text-white align'>
                    <h3>Shop</h3>

                    <div className="d-flex justify-content-center pt-3"> <nav aria-label="breadcrumb ">
                        <ol class="breadcrumb ">
                            <li class="breadcrumb-item"><a href="Home">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="Shop">Shop</li>
                        </ol>
                    </nav></div>

                </div>
                <div class='col-12 col-md-4 py-5'>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" placeholder="Keywords..." aria-label="Recipient's username" aria-describedby="basic-addon2" />
                        <span class="input-group-text bg-dark text-white" id="basic-addon2"><i class="fa-solid fa-magnifying-glass"></i></span>
                    </div>
                    <div className="py-5">
                        <h3>By Category</h3>
                        <ul className="bg-secondary-subtle text-center p-3">
                            <li className="bg-white m-1">Headlamps (2376)</li>
                            <li className="bg-white m-1">disk break (237)</li>
                            <li className="bg-white m-1">Turbo Oil (23)</li>
                            <li className="bg-white m-1">Tyre & metal wheel (258)</li>
                            <li className="bg-white m-1">Battery (67)</li>
                            <li className="bg-white m-1">Suspension (123)</li>
                            <li className="bg-white m-1">Shock Absorber  (23)</li>
                        </ul>
                    </div>

                    <div className="py-5">
                        <h3>Top Selling</h3>
                        <ul className="bg-secondary-subtle text-center p-2">
                            <li className="bg-white m-2"><div class='row'>
                                <div class='col-3'><img src={shop2} /></div>
                                <div class='col-9'><p>Suspenstion</p>
                                </div>
                            </div></li>
                            <li className="bg-white m-2"><div class='row'>
                                <div class='col-3'><img src={shop2} /></div>
                                <div class='col-9'><p>Disk Break</p>
                                </div>
                            </div></li>
                            <li className="bg-white m-2"><div class='row'>
                                <div class='col-3'><img src={shop3} /></div>
                                <div class='col-9'><p>Stearing wheel</p>
                                </div>
                            </div></li>
                            <li className="bg-white m-2"><div class='row'>
                                <div class='col-3'><img src={shop4} /></div>
                                <div class='col-9'><p>Shock Absorber</p>
                                </div>
                            </div></li>

                        </ul>
                    </div>



                </div>
                <div className="col-12 col-md-8 py-5">
                    <div className="row py-5">
                        <div class="card col-4 " >
                            <img src={shop1} class="card-img-top" alt="..." />
                            <div class="card-body">

                                <p class="card-text">Car Battery <span className="orange">$180.00</span></p>
                                <a href="#"><i class="fa-solid fa-cart-shopping orange"></i></a>
                            </div>
                        </div>
                        <div class="card col-4" >
                            <img src={shop2} class="card-img-top" alt="..." />
                            <div class="card-body">
                                <p class="card-text">Car Disk Break <span className="orange ">$80.00</span></p>
                                <a href="#"><i class="fa-solid fa-cart-shopping orange"></i></a>
                            </div>
                        </div>
                        <div class="card col-4" >
                            <img src={shop3} class="card-img-top" alt="..." />
                            <div class="card-body">
                                <p class="card-text">Steering Wheel<span className="orange ">$132.00</span></p>
                                <a href="#"><i class="fa-solid fa-cart-shopping orange"></i></a>

                            </div>
                        </div>
                    </div>

                    <div className="row py-5">
                        <div class="card col-4" >
                            <img src={shop3} class="card-img-top" alt="..." />
                            <div class="card-body">
                                <p class="card-text">Steering Wheel<span className="orange ">$132.00</span></p>
                                <a href="#"><i class="fa-solid fa-cart-shopping orange"></i></a>

                            </div>
                        </div>
                        <div class="card col-4 " >
                            <img src={shop1} class="card-img-top" alt="..." />
                            <div class="card-body">

                                <p class="card-text">Car Battery <span className="orange">$180.00</span></p>
                                <a href="#"><i class="fa-solid fa-cart-shopping orange"></i></a>
                            </div>
                        </div>
                        <div class="card col-4" >
                            <img src={shop2} class="card-img-top" alt="..." />
                            <div class="card-body">
                                <p class="card-text">Car Disk Break <span className="orange ">$80.00</span></p>
                                <a href="#"><i class="fa-solid fa-cart-shopping orange"></i></a>
                            </div>
                        </div>

                    </div>
                    <div className="row py-5">
                        <div class="card col-4 " >
                            <img src={shop1} class="card-img-top" alt="..." />
                            <div class="card-body">

                                <p class="card-text">Car Battery <span className="orange">$180.00</span></p>
                                <a href="#"><i class="fa-solid fa-cart-shopping orange"></i></a>
                            </div>
                        </div>
                        <div class="card col-4" >
                            <img src={shop2} class="card-img-top" alt="..." />
                            <div class="card-body">
                                <p class="card-text">Car Disk Break <span className="orange ">$80.00</span></p>
                                <a href="#"><i class="fa-solid fa-cart-shopping orange"></i></a>
                            </div>
                        </div>
                        <div class="card col-4" >
                            <img src={shop3} class="card-img-top" alt="..." />
                            <div class="card-body">
                                <p class="card-text">Steering Wheel<span className="orange ">$132.00</span></p>
                                <a href="#"><i class="fa-solid fa-cart-shopping orange"></i></a>

                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </section>
    )
};

export default Shop;
